;(function(){
  'use strict';
  if(window.FFWishlist)return;

  var KEY='ff_wishlist';
  var EVT='ff:wishlist:change';

  /* ─ Storage ─ */
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function save(list){try{localStorage.setItem(KEY,JSON.stringify(list));}catch(e){}document.dispatchEvent(new CustomEvent(EVT,{detail:{list:list}}));}
  function has(id){return get().some(function(p){return String(p.id)===String(id);});}
  function add(d){var l=get();if(!has(d.id)){l.unshift({id:String(d.id),handle:d.handle||'',title:d.title||'',price:d.price||'',image:d.image||'',url:d.url||('/products/'+(d.handle||'')),addedAt:Date.now()});save(l);}}
  function remove(id){save(get().filter(function(p){return String(p.id)!==String(id);}));}
  function toggle(d){if(has(d.id)){remove(d.id);return false;}add(d);return true;}
  function count(){return get().length;}

  window.FFWishlist={has:has,add:add,remove:remove,toggle:toggle,getAll:get,count:count};

  /* ─ Inject global styles ─ */
  var st=document.createElement('style');
  st.textContent='.ff-wish-header{display:inline-flex;align-items:center;position:relative;color:inherit;text-decoration:none;padding:6px;margin-right:2px;}'+
    '.ff-wish-count{position:absolute;top:-3px;right:-3px;background:#A0304D;color:#fff;border-radius:100px;min-width:16px;height:16px;font-size:9px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;padding:0 3px;line-height:1;pointer-events:none;}'+
    '.ff-wish-count.is-hidden{display:none;}'+
    '.ff-wish-toast{position:fixed;bottom:5rem;left:50%;transform:translateX(-50%) translateY(6px);background:#231218;color:#FDF7F2;border-radius:100px;padding:10px 22px;font-size:.8125rem;font-weight:600;z-index:10000;opacity:0;transition:opacity .2s,transform .2s;pointer-events:none;white-space:nowrap;box-shadow:0 4px 20px rgba(35,18,24,.2);}'+
    '.ff-wish-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);pointer-events:all;}'+
    '.ff-wish-toast a{color:#EDD0D9;text-decoration:underline;text-underline-offset:2px;margin-left:8px;}';
  document.head.appendChild(st);

  /* ─ Toast ─ */
  function toast(msg,isAdd){
    var t=document.getElementById('ff-wish-toast');
    if(!t){t=document.createElement('div');t.id='ff-wish-toast';t.className='ff-wish-toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');document.body.appendChild(t);}
    t.innerHTML=msg+(isAdd?' — <a href="/pages/wishlist">View wishlist</a>':'');
    t.classList.add('is-visible');
    clearTimeout(t._t);
    t._t=setTimeout(function(){t.classList.remove('is-visible');},3000);
  }

  /* ─ Sync all heart buttons ─ */
  function sync(){
    document.querySelectorAll('[data-ff-wish-id]').forEach(function(btn){
      var active=has(btn.dataset.ffWishId);
      btn.classList.toggle('is-wished',active);
      btn.setAttribute('aria-pressed',active?'true':'false');
      btn.setAttribute('aria-label',active?'Remove from wishlist':'Save to wishlist');
    });
    updateCount();
  }

  /* ─ Count badge ─ */
  function updateCount(){
    var n=count();
    document.querySelectorAll('.ff-wish-count').forEach(function(el){
      el.textContent=n;
      el.classList.toggle('is-hidden',n===0);
    });
  }

  /* ─ Header icon ─ */
  function injectHeader(){
    if(document.getElementById('ff-wish-hdr'))return;
    var anchor=document.querySelector('cart-icon')||document.querySelector('[data-cart-icon]')||document.querySelector('header a[href="/cart"]');
    if(!anchor)return;
    var el=document.createElement('a');
    el.id='ff-wish-hdr';
    el.href='/pages/wishlist';
    el.className='ff-wish-header';
    el.setAttribute('aria-label','My Wishlist');
    el.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="ff-wish-count is-hidden" aria-hidden="true">0</span>';
    anchor.parentNode.insertBefore(el,anchor);
    updateCount();
  }

  /* ─ Heart click ─ */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-ff-wish-id]');
    if(!btn||btn.dataset.ffAdding)return;
    e.preventDefault();e.stopPropagation();
    var d={id:btn.dataset.ffWishId,handle:btn.dataset.ffWishHandle||'',title:btn.dataset.ffWishTitle||'',price:btn.dataset.ffWishPrice||'',image:btn.dataset.ffWishImage||'',url:btn.dataset.ffWishUrl||''};
    var added=toggle(d);
    btn.dataset.ffAdding='1';
    btn.classList.add('is-animating');
    setTimeout(function(){btn.classList.remove('is-animating');delete btn.dataset.ffAdding;},420);
    toast(added?'\u2661 Saved to wishlist':'Removed from wishlist',added);
  });

  document.addEventListener(EVT,sync);

  /* ─ Init ─ */
  function init(){sync();injectHeader();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);

})();
